// Import model
import { CreateContactAppointmentRequest } from '../models/CreateContactAppointmentRequest';

// Import base class serializer

// Import dependency types (models and enums used in properties)
import { CreateAddressRequest } from '../models/CreateAddressRequest';

// Import dependency serializers (for complex types)
import { CreateAddressRequestSerializer } from './CreateAddressRequestSerializer';

// Import derived type serializers (for polymorphic deserialization)

/**
 * Serializer for CreateContactAppointmentRequest - handles JSON serialization and deserialization with type validation
 */
export class CreateContactAppointmentRequestSerializer {
  /**
   * Deserializes a JSON string into a CreateContactAppointmentRequest instance
   */
  static deserialize(json: string): CreateContactAppointmentRequest {
    const obj = JSON.parse(json);
    return this.fromObject(obj);
  }

  /**
   * Deserializes a plain object into a CreateContactAppointmentRequest instance
   */
  static fromObject(obj: any): CreateContactAppointmentRequest {
    if (!obj) {
      throw new Error('Cannot deserialize null or undefined to CreateContactAppointmentRequest');
    }


    const instance: CreateContactAppointmentRequest = {
      parentObjectId: obj['parentObjectId'] as string,
      address: obj['address'] ? CreateAddressRequestSerializer.fromObject(obj['address']) : undefined as any,
      endDate: obj['endDate'] as string,
      isAllDay: obj['isAllDay'] as boolean | undefined,
      startDate: obj['startDate'] as string,
      timeZoneId: obj['timeZoneId'] as string,
      name: obj['name'] as string | undefined,
      description: obj['description'] as string | undefined,
      flowId: obj['flowId'] as string | undefined,
      objectStatusId: obj['objectStatusId'] as string | undefined,
      createdBy: obj['createdBy'] as string | undefined,
      content: obj['content'] as string | undefined,
      contentType: obj['contentType'] as string | undefined,
      creatorId: obj['creatorId'] as string | undefined,
      entityId: obj['entityId'] as string | undefined,
      isActive: obj['isActive'] as boolean | undefined,
      relatedObjects: obj['relatedObjects'] as string | undefined,
    };

    return instance;
  }

  /**
   * Deserializes a JSON string into an array of CreateContactAppointmentRequest instances
   */
  static deserializeArray(json: string): CreateContactAppointmentRequest[] {
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) {
      throw new Error('Expected JSON array');
    }
    return arr.map(obj => this.fromObject(obj));
  }

  /**
   * Serializes a CreateContactAppointmentRequest instance to a JSON string
   */
  static serialize(instance: CreateContactAppointmentRequest): string {
    return JSON.stringify(this.toObject(instance));
  }

  /**
   * Converts a CreateContactAppointmentRequest instance to a plain object
   */
  static toObject(instance: CreateContactAppointmentRequest): any {
    return {
      'parentObjectId': instance.parentObjectId,
      'address': instance.address ? CreateAddressRequestSerializer.toObject(instance.address) : undefined,
      'endDate': instance.endDate,
      'isAllDay': instance.isAllDay,
      'startDate': instance.startDate,
      'timeZoneId': instance.timeZoneId,
      'name': instance.name,
      'description': instance.description,
      'flowId': instance.flowId,
      'objectStatusId': instance.objectStatusId,
      'createdBy': instance.createdBy,
      'content': instance.content,
      'contentType': instance.contentType,
      'creatorId': instance.creatorId,
      'entityId': instance.entityId,
      'isActive': instance.isActive,
      'relatedObjects': instance.relatedObjects,
    };
  }

  /**
   * Serializes an array of CreateContactAppointmentRequest instances to a JSON string
   */
  static serializeArray(instances: CreateContactAppointmentRequest[]): string {
    return JSON.stringify(instances.map(inst => this.toObject(inst)));
  }
}
